import { render, staticRenderFns } from "./ConsiderRequestFromEmail.vue?vue&type=template&id=8a81b444&scoped=true"
import script from "./ConsiderRequestFromEmail.vue?vue&type=script&lang=js"
export * from "./ConsiderRequestFromEmail.vue?vue&type=script&lang=js"
import style0 from "./ConsiderRequestFromEmail.vue?vue&type=style&index=0&id=8a81b444&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a81b444",
  null
  
)

export default component.exports